export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const passwordRegex = /^(?=.*[a-ząćęłńóśźż])(?=.*[A-ZĄĆĘŁŃÓŚŹŻ])(?=.*\d)(?=.*[@$!%*?&_\W])[A-Za-ząćęłńóśźżĄĆĘŁŃÓŚŹŻ\d@$!%*?&_\W]{15,}$/;
